import { useQuery } from '@tanstack/react-query';
import { posterGradient } from '@/lib/posters';
import { EmptyState, PageHero } from '@/components/PagePlaceholder';
import { NotifyForm } from '@/components/NotifyForm';
import { Gamepad2 } from '@/components/icons';
import { catalogApi } from '@/features/catalog/api';

export function GamesPage() {
  const { data, isLoading } = useQuery({ queryKey: ['games'], queryFn: catalogApi.games });
  const games = data?.games ?? [];

  return (
    <div>
      <PageHero
        eyebrow="Games"
        title={games.length ? 'Play Nullify originals.' : 'Games are on the way.'}
        subtitle="Interactive experiences from Nullify Entertainment. BingeBox and BingeBox+ subscribers get access."
      />
      <div className="container-page pb-16">
        {isLoading ? (
          <p className="text-sm text-ink-faint">Loading…</p>
        ) : games.length === 0 ? (
          <EmptyState
            icon={<Gamepad2 size={26} strokeWidth={1.75} />}
            title="There's nothing here yet"
            description="Drop your email and we'll let you know the moment the first game goes live."
            action={<NotifyForm topic="games" />}
          />
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {games.map((g) => (
              <a
                key={g.id}
                href={g.embedUrl ?? '#'}
                target={g.embedUrl ? '_blank' : undefined}
                rel="noreferrer"
                className="card overflow-hidden transition-transform hover:scale-[1.01]"
              >
                <div
                  className="aspect-video w-full"
                  style={g.thumbnailUrl ? { backgroundImage: `url(${g.thumbnailUrl})`, backgroundSize: 'cover' } : { backgroundImage: posterGradient(g.id) }}
                />
                <div className="p-4">
                  <p className="font-display font-bold text-ink">{g.title}</p>
                  <p className="mt-1 line-clamp-2 text-sm text-ink-muted">{g.description}</p>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
